export default __webpack_public_path__ + "static/media/7C.ca5e6b45.webp";